"use strict";

class PropertyStackViewController {
    constructor(
        $scope,
        $localStorage,
        $timeout,
        Fullscreen,
        SSHttpService,
        SSUserService,
        SSAppService,
        SSUtilService,
        SSAlertService,
        SSStackviewService
    ) {
        const self = this;

        self.$scope = $scope;
        self.$storage = $localStorage;
        self.$timeout = $timeout;
        self.Fullscreen = Fullscreen;
        self.SSHttpService = SSHttpService;
        self.SSUserService = SSUserService;
        self.SSAppService = SSAppService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSStackviewService = SSStackviewService;

        self.data = SHOWSUITE.data;

        self.AVAILABILITY_PUBLIC = SHOWSUITE.AVAILABILITY_PUBLIC;
        self.AVAILABILITY_BROKERS_ALL = SHOWSUITE.AVAILABILITY_BROKERS_ALL;
        self.AVAILABILITY_BROKERS_TEAM = SHOWSUITE.AVAILABILITY_BROKERS_TEAM;

        self.PROPERTY_TYPE_LANDED = SHOWSUITE.PROPERTY_TYPE_LANDED;

        self.AUTO_REFRESH_TIME = SHOWSUITE.AUTO_REFRESH_TIME;

        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED =
            SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.FLOORPLAN_ASSET_TYPE_360_IMAGE =
            SHOWSUITE.FLOORPLAN_ASSET_TYPE_360_IMAGE;

        self.UNIT_CATEGORIES_MAP = {
            0: { code: 'XX', name: 'Other', className: 'empty' },
            1: { code: '1BR', name: '1 Bedroom', className: 'bed1' },
            2: { code: '2BR', name: '2 Bedroom', className: 'bed2' },
            3: { code: '3BR', name: '3 Bedroom', className: 'bed3' },
            4: { code: '4BR', name: '4 Bedroom', className: 'bed4' },
            5: { code: '5BR', name: '5 Bedroom', className: 'bed5' },
            6: { code: 'PH', name: 'Penthouse', className: 'ph' },
            7: {code: 'COM', name: 'Commercial', className: 'retail'},
            1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
            2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
            3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
            4000: { code: 'DE', name: 'Detached', className: 'detached' },
            4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
            4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };

        self.STATUS_REFRESH_TIME_LIMIT = 5000; // milliseconds
        self.sold_status_visibility = false;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.stacks = [];
        self.stackViewType = 1;
        self.propertyUnitCategories = [];

        if (self.data.hasOwnProperty("property")) {
            self.getProperty(self.data.property.named_id);
        }

        /** WEB-2860 Stack View: Need to add more details in each cell - START **/
        self.stackviewSettings = { // Init stackview_settings defaults
            show_floor_pan: false
        }
        if( self.SSStackviewService.getStackViewSettings() ){
            self.stackviewSettings = self.SSStackviewService.getStackViewSettings(self.stackviewSettings);
        }
        /** WEB-2860 Stack View: Need to add more details in each cell - END **/

        self.$scope.$watch(() => self.stackviewSettings, (newVal, oldVal) => {
            if (newVal) {
                self.processStackViewSettings();
            }
        }, true);
    }

    getProperty(propertyId) {
        const self = this;

        self.data.property_id = propertyId;
        if (!self.data.property_id) return;

        // self.getProjectSettings(propertyId);

        self.property = null;
        let url = "sec/developer/properties/" + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            // self.stats = response.data.stats;
            // self.typeMaps = response.data.type_map;
            // self.unitTypes = response.data.unit_types;
            self.unitsData = response.data.units_data;
            self.getUnits();
            // WEB-3360: fetch live unit statuses on initial load so counters
            // (sold / booked / reserved / OTP issued) are correct before the
            // user touches the "Sold Status Visibility" switch.
            self.getUnitStatuses();
        });
    }

    getUnits(show_loading = true) {
        const self = this;

        if (!self.property.id) {
            return;
        }

        let url = "properties/" + self.property.id + "/stacks";

        let params = {
            response_md5: self.response_md5,
            return_property: true,
            property_columns:
                "id,named_id,name,type,product_type,status,location,country,region",
            return_stack: true,
            stack_columns: "id,named_id,name,row_index,col_index",
            include_units: true,
            include_unit_assets: true,
            unit_columns:
                "id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf,floor_plan_3d,position",
        };

        if (show_loading) {
            loading(true);
        }

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.sub_code == 204001) {
                return;
            }

            self.response_md5 = response.data.response_md5;
            self.units = response.data.property_stacks;
            self.getPropertyStacks(show_loading);
            // Get unit allocation data to check which agencies are assigned to which units
            // self.getUnitAllocationData(self.property.id);
        });
    }

    checkStackViewVisibility(named_id){
        const self = this;

        if(!(self.property && self.property.named_id)){
            return false;
        }

        if(self.property.named_id == named_id){
            return true;
        } else if(self.property.named_id != 'the-reserve-residences' 
            && self.property.named_id != 'lentor-hills-residences' 
            && self.property.named_id != 'the-lakegarden-residences' 
            && self.property.named_id != 'hillhaven' 
            && self.property.named_id != 'lentoria' 
            && self.property.named_id != 'the-hill-at-one-north' 
            && self.property.named_id != 'the-hillshore' 
            && named_id == 'index'){
            return true;
        }

        return false;
    }

    getPropertyStacks() {
        const self = this;

        // self.sold_count = '0';

        let _STACKS = self.units;

        // self.checkListViewOnly();
        self.processServerData(_STACKS);
        self.getPropertyUnitTypes();
        self.processStackViewSettings();
    }

    processServerData(_STACKS) {
        const self = this;

        self.units_view_master = [];

        if (!_STACKS) {
            self.stacks = [];
            return;
        }

        self.all_units = [];

        // If property changed then update stacks
        if (
            self.stacks.length == 0 ||
            self.viewType == 2 ||
            (self.stacks.length > 0 &&
                _STACKS.length > 0 &&
                self.stacks[0].named_id != _STACKS[0].named_id) ||
            self.viewType == 3
        ) {
            self.stacks = _STACKS;
            jQuery.each(self.stacks, function (i, stack) {
                stack.floorsData = self.SSUtilService.getFloorWiseUnits(
                    stack.units
                );
                stack.availableUnits = self.filterAvailableUnits(stack.units);
                $.merge(self.all_units, stack.units);
                if (stack.availableUnits && stack.availableUnits.length > 0) {
                    self.availableUnits = stack.availableUnits;
                }
            });
        } else {
            // Find the updated data from stacks array and replace in old stacks array
            jQuery.each(self.stacks, function (i, old_stack) {
                let new_stack = _STACKS[i];

                if (!new_stack) {
                    return false;
                }

                if (!_.isEqual(old_stack, new_stack)) {
                    let newFloorsData = self.SSUtilService.getFloorWiseUnits(
                        new_stack.units
                    );
                    let newAvailableUnits = self.filterAvailableUnits(
                        new_stack.units
                    );

                    // Update floors data if changed
                    if (!_.isEqual(old_stack.floorsData, newFloorsData)) {
                        $.each(old_stack.floorsData, function (f, floor) {
                            if (!_.isEqual(floor, newFloorsData[f])) {
                                floor = newFloorsData[f];
                                // Update unit class
                                $.each(floor, function (_f, f_unit) {
                                    self.updateUnitClass(f_unit);
                                });
                            }
                        });
                    }

                    // Update units data if changed
                    if (!_.isEqual(old_stack.units, new_stack.units)) {
                        $.each(old_stack.units, function (u, _unit) {
                            if (!_.isEqual(_unit, new_stack.units[u])) {
                                _unit = new_stack.units[u];
                                self.updateUnitClass(_unit);
                            }
                        });
                    }

                    // Update available units
                    // availableUnits can increase (if sale aborted) or decrease (if unit sold out)
                    if (
                        !_.isEqual(old_stack.availableUnits, newAvailableUnits)
                    ) {
                        if (
                            old_stack.availableUnits.length <
                            newAvailableUnits.length
                        ) {
                            // Need to push the new available unit to old stack
                            $.each(newAvailableUnits, function (u, new_unit) {
                                let _unit = old_stack.availableUnits.find(
                                    (x) => x.id == new_unit.id
                                );
                                if (!_unit) {
                                    self.updateUnitClass(_unit);
                                    old_stack.availableUnits.push(new_unit);
                                }
                            });
                        } else if (
                            old_stack.availableUnits.length >
                            newAvailableUnits.length
                        ) {
                            // Need to remove updated unit from old stack
                            $.each(
                                old_stack.availableUnits,
                                function (index, old_unit) {
                                    // If old unit not found in new available units then it is removed when data updated
                                    let _unit = newAvailableUnits.find(
                                        (x) => x.id == old_unit.id
                                    );
                                    self.updateUnitClass(_unit);
                                    if (!_unit) {
                                        // Remove 1 item/object from given position/index
                                        old_stack.availableUnits.splice(
                                            index,
                                            1
                                        );
                                    }
                                }
                            );
                        }
                    }
                }

                $.merge(self.all_units, new_stack.units);
            });
        }

        self.loadUnitsView();

        if (self.stacks && self.stacks.length > 0) {
            self.selectedStackId = self.selectedStackId
                ? self.selectedStackId
                : self.stacks[0].id;
        }

        /** WEB-2771 All Stack View - Blocks Arrangement for New Projects **/
        if(self.property.type == self.PROPERTY_TYPE_LANDED){
            self.processUnitArrangment(self.stacks)
        }else{
            self.processStacksArrangment(self.stacks);
        }

        self.$timeout(function(){
            self.toggleUnitsStatus();
            self.SSAppService.isPageLoaded = true;

            /** WEB-2771 All Stack View - Blocks Arrangement for New Projects **/
            self.initStackDragDrop();
        });
    }

    loadUnitsView() {
        const self = this;

        let _units_view = [];

        if (!self.units_view_master.length) {
            self.units_view_master = self.availableUnits || [];
        }

        self.count = self.units_view_master.length;
        self.pages = Math.ceil(self.count / self.apiLimit);
        self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        self.pagesArr = [];

        for (var i = 0; i < self.pages; i++) {
            self.pagesArr.push(i);
        }

        for (var i = 0; i < self.apiLimit; i++) {
            if (self.apiOffset + i < self.count) {
                _units_view.push(self.units_view_master[self.apiOffset + i]);
            }
        }

        self.units_view = _units_view;
    }

    updateUnitClass(unit) {
        const self = this;

        if ($("#" + unit.id).hasClass("reserved")) {
            $("#" + unit.id).removeClass("reserved");
        }
        if ($("#" + unit.id).hasClass("sold")) {
            $("#" + unit.id).removeClass("sold");
        }
        if(unit.status == self.UNIT_STATUS_DRAFT){
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                let category = self.UNIT_CATEGORIES_MAP[unit.category];
                if(category) {
                    if ($("#" + unit.id).hasClass(category.className)) $('#'+unit.id).removeClass(category.className);
                }
            }
        }

        $("#" + unit.id).addClass(self.getUnitCellClass(unit));
    }

    checkListViewOnly() {
        const self = this;

        let stack_view_visibility = self.SSAppService.getPropertySetting(
            self.property,
            "stack_view_visibility"
        );

        if (
            stack_view_visibility !== null &&
            typeof stack_view_visibility === "object" &&
            stack_view_visibility.hasOwnProperty("value") &&
            stack_view_visibility.value != null
        ) {
            stack_view_visibility = stack_view_visibility.value;
        }

        if (stack_view_visibility == self.AVAILABILITY_BROKERS_TEAM) {
            if (!self.SSUserService.isBroker()) {
                self.viewType = self.stackViewType;
                self.disable_stackview = true;
                return;
            } else {
                loading(true);
                self.SSUserService.getBrokerAgencyWithProperty(property).then(
                    function (response) {
                        loading(false);
                        if (response instanceof Error) {
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }
                        if (!(response.data && response.data.properties)) {
                            self.viewType = self.stackViewType;
                            self.disable_stackview = true;
                            return;
                        }

                        let properties = response.data.properties;

                        $.each(properties, function (index, _property) {
                            if (_property.id === self.property.id) {
                                self.viewType = self.stackViewType;
                                return;
                            }
                        });

                        if (self.viewType !== 1) {
                            // self.viewType = 1;
                            self.disable_stackview = true;
                            return;
                        }
                    }
                );
            }
        } else if (stack_view_visibility == self.AVAILABILITY_BROKERS_ALL) {
            if (self.SSUserService.isBroker()) {
                self.viewType = self.stackViewType;
            } else {
                self.viewType = self.stackViewType;
                self.disable_stackview = true;
                return;
            }
        } else if (stack_view_visibility == self.AVAILABILITY_PUBLIC) {
            self.viewType = self.stackViewType;
        } else {
            self.viewType = self.stackViewType;
            self.disable_stackview = true;
        }
    }

    filterAvailableUnits(units) {
        const self = this;

        let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED];
        let filtered = [];

        _.each(units, function (unit) {
            unit.cls = self.getUnitCellClass(unit);
            if (statuses.indexOf(unit.status) !== -1) filtered.push(unit);
        });

        if (self.sortBy) {
            filtered = _.sortBy(filtered, function (item) {
                return item[self.sortBy];
            });
        }

        return filtered;
    }

    /**
     * Toggle handler for the "Sold Status Visibility" switch on the Stackview
     * Detail page.
     *
     * WEB-3360: this now only controls the per-cell styling in the stackview
     * grid (masking SOLD/BOOKED/RESERVED tiles as LISTED when the toggle is
     * off). It no longer mutates the counter strip — counter values come
     * unconditionally from getUnitStatuses() so the numbers stay accurate
     * regardless of the toggle state. The counter template itself decides
     * whether to display the "reserved as sold" view based on
     * stackviewSettings.show_reserved_as_sold && sold_status_visibility.
     */
    toggleUnitsStatus(){
        const self = this;

        self.sold_status_visibility = event? event.target.checked : false;

        if(!self.sold_status_visibility){
            // Mask per-cell status in the grid only (counters are unaffected).
            $.each(self.all_units, function(i, unit){
                unit.status = self.UNIT_STATUS_LISTED;
                self.updateUnitClass(unit);
            });
        } else {
            // Re-fetch immediately so cell classes reflect live statuses.
            let show_loading = true;
            self.getUnitStatuses(show_loading);
        }
    }

    /**
     * Fetch live unit statuses for the property's stacks and recompute the
     * counter strip (TOTAL / AVAILABLE / SOLD / OTP ISSUED) shown above the
     * stackview grid.
     *
     * WEB-3360: this runs unconditionally on initial load and every
     * STATUS_REFRESH_TIME_LIMIT ms thereafter. The "Sold Status Visibility"
     * toggle (self.sold_status_visibility) is now a pure display flag handled
     * by toggleUnitsStatus(); it does not gate the API call any more. That
     * prevents the symptom where counters read "--" on a property that has
     * reservations but no OTP yet.
     *
     * @param {boolean} show_loading Whether to render the loading spinner.
     */
    getUnitStatuses(show_loading = true){
        const self = this;

        if (!self.data || !self.data.property_id) {
            return;
        }

        let url = "properties/" + self.data.property_id + "/stacks/unit-status";
        if (self.stackviewSettings && self.stackviewSettings.show_last_assigned_unit){
            url +="?include=last_assigned_info"
        }

        loading(show_loading);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            // Auto refresh
            self.$timeout(function () {
                self.getUnitStatuses(false);
            }, self.STATUS_REFRESH_TIME_LIMIT);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.property_stacks){
                let sold_units = 0;
                let booked_units = 0;
                let reserved_units = 0;
                let otp_issued = 0;

                $.each(response.data.property_stacks, function(i, stack){
                    $.each(stack.units, function(j, _unit){
                        let unit = self.all_units ? self.all_units.find(x => x.id == _unit.id) : null;

                        if (unit) {
                            unit.status = _unit.status;
                            self.updateUnitClass(unit);
                        }

                        if(_unit.status == self.UNIT_STATUS_SOLD){
                            sold_units += 1;
                        } else if(_unit.status == self.UNIT_STATUS_BOOKED){
                            booked_units += 1;
                            otp_issued += 1;
                        } else if(_unit.status == self.UNIT_STATUS_RESERVED){
                            reserved_units += 1;
                        }
                    });
                });

                if (self.unitsData) {
                    self.unitsData.sold       = sold_units;
                    self.unitsData.booked     = booked_units;
                    self.unitsData.reserved   = reserved_units;
                    self.unitsData.otp_issued = otp_issued;
                    self.unitsData.remaining  = self.unitsData.total - (sold_units + booked_units + reserved_units);
                }
            }
            self.last_assigned_info = null;
            if(response.data && response.data.last_assigned_info){
                let last_assigned_info = response.data.last_assigned_info;
                self.last_assigned_info = {
                    unit_no: last_assigned_info.last_assigned_unit_no,
                    queue_no: last_assigned_info.queue_no,
                    agency: last_assigned_info.agency_name
                }
            }
        });
    }

    getUnitCellClass(unit) {
        const self = this;

        let cls = "";

        if (!unit.category) {
            cls = "empty";
        } else if (unit.status == self.UNIT_STATUS_LISTED) {
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
            } else {
                cls = self.UNIT_CATEGORIES_MAP[0].className;
            }
        } else if (unit.status == self.UNIT_STATUS_SOLD) {
            cls = "sold";
        } else if (unit.status == self.UNIT_STATUS_DRAFT) {
            cls = "draft";
        } else {
            cls = "reserved";
        }

        return cls;
    }

    // Fullscreen
    toggleFullscreen($event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
        } else {
            if (!$event) return;

            if (typeof $event == "string") {
                self.Fullscreen.enable(document.getElementById($event));
            } else if ($event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable($event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable($event.currentTarget);
            }
        }
    }

    get360photoClass(unit) {
        const self = this;

        if (
            self.checkUnitAssetClass(unit, self.FLOORPLAN_ASSET_TYPE_360_IMAGE)
        ) {
            return "360photo";
        }
    }

    get3DFloorPlanClass(unit) {
        if (
            unit.floor_plan_3d != null &&
            unit.floor_plan_3d != "" &&
            unit.floor_plan_3d != undefined
        ) {
            return "3Dfloorplan";
        }
    }

    checkUnitAssetClass(unit, floorPlanType) {
        const self = this;

        if (
            unit.hasOwnProperty("unit_assets") &&
            unit.unit_assets.length > 0 &&
            unit.unit_assets.find((x) => x.type == floorPlanType)
        ) {
            return true;
        }
    }

    getStackCol(stack, index) {
        const self = this;
        if (!stack) return;

        if (stack.floorsData && stack.floorsData.length) {
            if (_.size(stack.floorsData[0])) {
                if ((_.size(stack.floorsData[0]) / 2) < 4) {
                    return "col-" + (_.size(stack.floorsData[0]) / 2) + " px-0";
                }
                else if((_.size(stack.floorsData[0]) / 2) == 4){
                    return "col-" + ((_.size(stack.floorsData[0]) / 2)-1) + " px-0";
                }
                else{
                    return "col-" + ((_.size(stack.floorsData[0]) / 2)-2) + " px-0";
                }
            }
            return;
        }
        return;
    }

    getPropertyUnitTypes() {
        const self = this;

        let _propertyUnitCategories = [];
        let sold_units = 0;

        jQuery.each(self.stacks, function (i, stack) {
            jQuery.each(stack.units, function (j, unit) {
                let category = null;
                if (unit.category in self.UNIT_CATEGORIES_MAP) {
                    category = self.UNIT_CATEGORIES_MAP[unit.category];
                } else {
                    category = self.UNIT_CATEGORIES_MAP[0];
                }

                if (_propertyUnitCategories.indexOf(category) == -1) {
                    _propertyUnitCategories.push(category);
                }

                if (unit.status == self.UNIT_STATUS_SOLD) {
                    sold_units += 1;
                }
            });
        });

        self.sold_count = sold_units;
        self.propertyUnitCategories = _propertyUnitCategories;
    }

    /** WEB-2771 All Stack View - Blocks Arrangement for New Projects - START **/
    initStackDragDrop(){
        const self = this;

        if(self.property.type == self.PROPERTY_TYPE_LANDED){
            // Add event listeners to the draggable items
            var draggables = document.querySelectorAll('.draggable');
            draggables.forEach(function(draggable) {
                draggable.addEventListener('dragstart', unitDragStart);
                draggable.addEventListener('dragend', unitDragEnd);
            });

            // Add event listeners to the landed stacks container
            var landedStackContainer = document.getElementById('landed-stack-container');
            landedStackContainer.addEventListener('dragover', allowDrop);
        }else{
            // Add event listeners to the draggable items
            var draggables = document.querySelectorAll('.draggable');
            draggables.forEach(function(draggable) {
                draggable.addEventListener('dragstart', dragStart);
            });

            // Add event listeners to the flex containers
            var flexContainers = document.querySelectorAll('.drag-drop-row');
            flexContainers.forEach(function(container) {
                container.addEventListener('dragover', allowDrop);
                container.addEventListener('drop', drop);
            });
        }
    }

    processUnitArrangment(stacks){
        const self = this;
        if(!stacks){ return; }

        stacks.forEach(function (stack, row){
            if(stack.units && stack.units.length){
                let floorCount = {};
                stack.units.forEach((unit, col) => {
                    floorCount[unit.floor_no] = (floorCount[unit.floor_no] > -1)? floorCount[unit.floor_no] + 1: 0;
                    let defaultPosition = {
                        x: floorCount[unit.floor_no] * 50,
                        y: (unit.floor_no-1) * 28,
                        width: 50,
                        height: 28,
                        rotation: 0
                    }
                    unit.defaultPosition = defaultPosition; // Set default position for reset
                    if(unit.position){
                        try{
                            unit.position = JSON.parse(unit.position);
                        }catch (e) { console.warn(e); }
                    }else{
                        unit.position = defaultPosition;
                    }
                    self.renderLandedUnits(unit);
                });
            }
        })
    }

    processStacksArrangment(stacks){
        const self = this;
        if(!stacks){ return; }

        self.stacks_arrangement = [];
        let unpositionedStacks = [];
        // Position stacks based on rows
        stacks.forEach(function (stack){
            if((stack.row_index !== null && stack.row_index > -1) &&
                (stack.col_index !== null && stack.col_index > -1)){
                self.stacks_arrangement[stack.row_index] = self.stacks_arrangement[stack.row_index] || []
                self.stacks_arrangement[stack.row_index].push(stack);
            }else{
                unpositionedStacks.push(stack);
            }
        })

        // Sort stacks in row based on col_index
        if(self.stacks_arrangement && self.stacks_arrangement.length){
            self.stacks_arrangement = self.stacks_arrangement.map(stackRow=> {
                return stackRow.sort((a, b) => a.col_index - b.col_index);
            })
        }

        // If there are unpositioned stacks, palce them in a new row
        if(unpositionedStacks && unpositionedStacks.length){
            let lastRowInex = self.stacks_arrangement.length || 0;
            self.stacks_arrangement[lastRowInex] = self.stacks_arrangement[lastRowInex] || [];
            unpositionedStacks.forEach(function(stack){
                self.stacks_arrangement[lastRowInex].push(stack)
            })
        }
    }

    editArrangement(){
        const self = this;

        if(self.property.type === self.PROPERTY_TYPE_LANDED){
            $("#landed-stack-container .unit-blk").attr("draggable", true);
        }
        self.isEditingPosition = true;
    }

    saveArrangement(){
        const self = this;

        if(self.property.type === self.PROPERTY_TYPE_LANDED){
            let units_arrangement = [];
            $.each($(".draggable"), function (index, unitDiv){
                if($(unitDiv).attr("data-id")){
                    let unitPosition = {};
                    unitPosition.width = self.getParsedNumber($(unitDiv).attr("data-width")) || 20;
                    unitPosition.height = self.getParsedNumber($(unitDiv).attr("data-height")) || 20;
                    unitPosition.x = self.getParsedNumber($(unitDiv).attr("data-x")) || 0;
                    unitPosition.y = self.getParsedNumber($(unitDiv).attr("data-y")) || 0;
                    unitPosition.rotation = self.getParsedNumber($(unitDiv).attr("data-rotation")) || 0;

                    units_arrangement.push({
                        id: self.getParsedNumber($(unitDiv).attr("data-id")),
                        position: unitPosition
                    })
                }
            })

            if(units_arrangement && units_arrangement.length){
                let url = `sec/developer/properties/${self.property.named_id}/update-units-position`;
                let params = {
                    property_unit_position_data: JSON.stringify(units_arrangement)
                }
                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    $("#landed-stack-container .unit-blk").attr("draggable", false);
                    self.isEditingPosition = false;
                });
            }
        }else{
            let stacks_arrangement = [];

            $.each($(".drag-drop-row"), function (rowIndex, dragDropRow){
                let stackDivs = $(dragDropRow).find(".draggable");
                $.each(stackDivs, function (colIndex, stackDuv){
                    stacks_arrangement.push({
                        id: $(stackDuv).attr("data-stackId"),
                        row_index: rowIndex,
                        col_index: colIndex
                    })
                })
            })

            if(stacks_arrangement){
                let url = `sec/developer/properties/${self.property.id}/stacks/stacks-arrangement`;
                let params = {
                    stacks: JSON.stringify(stacks_arrangement)
                }
                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.isEditingPosition = false;
                });
            }
        }
    }

    getParsedNumber(value){
        const self = this;
        if(!value) { return 0; }
        return (isNaN(parseInt(value))? 0: parseInt(value));
    }

    renderLandedUnits(unit){
        const self = this;

        let defaultPosition = {
            x: 0, y: 0, width: 50, height: 28, rotation: 0
        }
        unit.position = unit.position || defaultPosition;

        if( $("#landed-stack-container").find("#unit-"+unit.id).length ){
            let updatedUnit = $("#landed-stack-container").find("#unit-"+unit.id);
            $(updatedUnit).css("width", unit.position.width+"px");
            $(updatedUnit).css("height", unit.position.height+"px");
            $(updatedUnit).css("top", unit.position.y+"px");
            $(updatedUnit).css("left", unit.position.x+"px");
            $(updatedUnit).css("transform", "rotate("+unit.position.rotation+"deg)");

            $(updatedUnit).attr("data-width", unit.position.width);
            $(updatedUnit).attr("data-height", unit.position.height);
            $(updatedUnit).attr("data-x", unit.position.x);
            $(updatedUnit).attr("data-y", unit.position.y);
            $(updatedUnit).attr("data-rotation", unit.position.rotation);
        }else{
            let _360photoClass = self.get360photoClass(unit) || '';
            let _3DFloorPlanClass = self.get3DFloorPlanClass(unit) || '';

            // If not already rendered, add new
            // WEB-2771: ${(!unit.category || unit.status != 20)? "disabled": ""} Set disabled if needed
            let unitDiv = `
                <button class="unit-blk stackview draggable ${unit.cls} ${_360photoClass} ${_3DFloorPlanClass}"
                    id="unit-${unit.id}"
                    data-id="${unit.id}"
                    data-width="${unit.position.width}"
                    data-height="${unit.position.height}"
                    data-x="${unit.position.x}"
                    data-y="${unit.position.y}"
                    data-rotation="${unit.position.rotation}"
                    onclick="selectUnitForPositioning(this)"
                    style="
                        width: ${unit.position.width}px;
                        height: ${unit.position.height}px;
                        position: absolute;
                        top: ${unit.position.y}px;
                        left: ${unit.position.x}px; 
                        transform: rotate(${unit.position.rotation}deg)">
                    <div class="tooltips">
                        <span> ${unit.category ? self.SSUtilService.getFullUnitNumber1(unit, false) : ''} </span>
                        ${unit.price ? `
                        <span class="tooltiptext">
                            ${ self.SSAppService.getFormattedAmountWithDecimal(unit.price, self.data.property.country) }
                        </span>
                        `: ''}
                    </div>
                </button>
            `;
            $("#landed-stack-container").html( $("#landed-stack-container").html() + unitDiv );
        }
    }

    syncUnitsPosition(){
        const self = this;
        self.stacks.forEach(stack => {
            stack.floorsData.forEach(unit => {
                $.each($("#landed-stack-container .draggable"), function(index, unitDiv){
                    let filteredUnit = stack.units.find(unit => unit.id == $(unitDiv).attr("data-id")); // Keep ==

                    filteredUnit.position.x = self.getParsedNumber($(unitDiv).attr("data-x")) || 0;
                    filteredUnit.position.y = self.getParsedNumber($(unitDiv).attr("data-y")) || 0;
                    self.renderLandedUnits(filteredUnit);
                })
            })
        })
    }

    openUnitPositionControls(unit){
        const self = this;

        self.stacks.forEach( stack => {
            stack.floorsData.forEach( floorUnits => {
                for( let unitIndex in floorUnits){
                    if(unit.id !== floorUnits[unitIndex].id){
                        floorUnits[unitIndex].selected = false;
                    }
                }
            });
        });

        // Toggle position controls for selected unit.
        unit.selected = !unit.selected;
    }

    resetUnitPosition(unit){
        const self = this;

        unit.position = angular.copy(unit.defaultPosition);
        self.renderLandedUnits(unit);
    }
    /** WEB-2771 All Stack View - Blocks Arrangement for New Projects - END **/

    processStackViewSettings() {
        const self = this;

        if (!self.stackviewSettings ||
            !self.stackviewSettings.wrap_units_setting ||
            !self.stackviewSettings.wrap_units_length_setting) {
            $(".draggable").css("max-width", "100%");
            return;
        }

        const wrapLength = parseInt(self.stackviewSettings.wrap_units_length_setting);
        if (isNaN(wrapLength) || wrapLength <= 0) {
            $(".draggable").css("max-width", "100%");
            return;
        }

        self.$timeout(() => {
            $(".draggable").each(function() {
                const $draggable = $(this);
                const $button = $draggable.find("button.stackview").first();
                if ($button.length) {
                    const buttonWidth = $button.outerWidth();
                    const $buttonsRowContainer = $draggable.find(".buttons-row-container").first();
                    const $buttonsRow = $draggable.find(".buttons-row").first();
                    const $floorLabel = $draggable.find(".floor-lbl").first();
                    const floorLabelWidth = $floorLabel.outerWidth();
                    const buttonsGap = parseInt($buttonsRow.css("gap")) || 0;
                    const buttonsRowContainerGap = parseInt($buttonsRowContainer.css("gap")) || 0;
                    
                    const calculatedMaxWidth =
                            (buttonWidth * wrapLength) +
                            (buttonsGap * (wrapLength - 1)) +
                            buttonsRowContainerGap +
                            floorLabelWidth;
                    const currentWidth = $draggable.width();

                    if (calculatedMaxWidth > 0 && calculatedMaxWidth <= currentWidth) {
                        $draggable.css("max-width", calculatedMaxWidth + "px");
                    } else {
                        $draggable.css("max-width", "100%");
                    }
                }
            });
        }, 100);
    }
}
PropertyStackViewController.$inject = [
    "$scope",
    "$localStorage",
    "$timeout",
    "Fullscreen",
    "SSHttpService",
    "SSUserService",
    "SSAppService",
    "SSUtilService",
    "SSAlertService",
    "SSStackviewService"
];
app.controller("PropertyStackViewController", PropertyStackViewController);
